import styled from 'styled-components';

export const AlmostOverHighlight = styled.span`
  color: #125de6;
`;

export const OverHighlight = styled.span`
  color: #f00;
`;

export const NoHighlight = styled.span``;
